import React from "react";
import EmulatorConfigView from "./EmulatorConfigView";

export default function VistaEPS() {
  return (
    <EmulatorConfigView
      subsystem="EPS"
      title="EPS"
      icon="⚡"
      description="Configura únicamente voltaje, potencia e impedancia, tal como están implementados en el PIC de EPS."
    />
  );
}
